// Una SEDE es una empresa hija que no gestiona su propio plan: hereda la
// vigencia del padre (BE: subscription.service.ts). Se decide con el `user` del
// login y NO con la empresa activa: cuando un master entra a una hija con el
// selector, `gs-company` pasa a ser la hija, pero quien opera es el master y sí
// puede gestionar el plan. Ver docs de jerarquía de empresas (isMaster tiene
// prioridad).
export const isSedeUser = (user) =>
  !!user && !user.isMaster && user.parentCompanyId != null;
